import { USACurrency } from '@loc/helpers/src/currency/data'
import NP from 'number-precision'

import type { TProduct } from '../type'

export function getCurrentPrice({
  productPrice,
}: {
  productPrice?: Pick<TProduct, 'price' | 'duration'>
}) {
  const currencyInfo = USACurrency

  if (!productPrice?.price) {
    return {
      currencyPrice: 0,
      currencyPriceMonth: 0,
      currencyPriceMonthText: '0',
      realCurrencyInfo: USACurrency,
    }
  }

  const iso = (currencyInfo?.iso || 'USD').toLowerCase()
  const isUSD = iso === 'usd'

  // const moreCurrency = productPrice?.more_currency as Record<string, number>

  // 处理没有设置多币种价格
  // let realIso = 'usd'

  // if (
  //   (!isUSD && moreCurrency?.[iso]) ||
  //   (!isUSD && !moreCurrency?.[iso] && productPrice.usage_count === 0)
  // ) {
  //   realIso = iso
  // }

  // const realCurrencyInfo = getCurrencyInfoByIso(realIso)! as typeof USACurrency

  // const _currencyPrice = moreCurrency?.[iso] || productPrice.price

  // const noDivisionNeeded = get(realCurrencyInfo, 'noDivisionNeeded', false)

  // const currencyPrice = noDivisionNeeded ? _currencyPrice : _currencyPrice / 100

  const currencyPrice = NP.divide(productPrice.price, 100)
  const currencyPriceMonth = NP.divide(currencyPrice, productPrice.duration)
  const currencyPriceMonthText = isUSD
    ? currencyPriceMonth.toFixed(2)
    : `${currencyPriceMonth}`

  return {
    currencyPrice,
    currencyPriceMonth,
    currencyPriceMonthText,
    realCurrencyInfo: USACurrency,
  }
}
